module.exports = __webpack_public_path__ + "assets/img/Future_005.68997fe0-ps.jpg";